import { useEffect, useState } from 'react';
import { Button, Snackbar } from '@mui/material';
import { useTranslation } from '../i18n';
import { watchForNewBuild } from '../lib/buildCheck';

// Offers a reload once a newer build is deployed. Not automatic: the user
// may be mid-way through a chat message or a form.
export function NewVersionNotice() {
  const t = useTranslation().common;
  const [open, setOpen] = useState(false);
  useEffect(() => watchForNewBuild(() => setOpen(true)), []);
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={t.newVersion}
      action={
        <Button color="primary" size="small" onClick={() => location.reload()}>
          {t.reload}
        </Button>
      }
    />
  );
}
